import React from 'react';
import ChatbotGrid from './ChatbotGrid';
import { motion } from 'framer-motion';

const ChatbotSection = ({ onNavigate }) => {
    return (
        <section className="py-20 px-4 relative overflow-hidden">
            {/* Standardized Background */}
            <div className="absolute inset-0 overflow-hidden">
                {/* Grid Pattern */}
                <div className="absolute inset-0 bg-[linear-gradient(rgba(255,255,255,0.02)_1px,transparent_1px),linear-gradient(to_right,rgba(255,255,255,0.02)_1px,transparent_1px)] bg-[size:64px_64px]" />

                {/* Gradient Orbs */}
                <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-blue-400/5 rounded-full blur-3xl" />
                <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-purple-400/5 rounded-full blur-3xl" />
            </div>

            <div className="max-w-6xl mx-auto relative">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.5 }}
                    className="text-center mb-16"
                >
                    <h2 className="text-5xl font-bold text-white mb-6">
                        DIO+ <span className="bg-clip-text text-transparent bg-gradient-to-r from-blue-400 to-purple-400">Assistant Suite</span>
                    </h2>
                    <p className="text-slate-300 text-xl max-w-3xl mx-auto leading-relaxed">
                        Advanced AI assistants tailored to each department's unique needs.
                    </p>
                </motion.div>

                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.5, delay: 0.2 }}
                >
                    <ChatbotGrid onNavigate={onNavigate} />
                </motion.div>
            </div>
        </section>
    );
};

export default ChatbotSection;